var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7525 6.99988H23.5927C25.9432 6.99988 27.8452 8.90189 27.8452 11.2523V12.1084H30.2475C32.598 12.1084 34.5 14.0104 34.5 16.3608V30.278C34.5 32.6284 32.598 34.5304 30.2475 34.5304H16.3304C13.9799 34.5304 12.0779 32.6284 12.0779 30.278V16.3608C12.0779 14.0104 13.9799 12.1084 16.3304 12.1084H25.5256V11.2523C25.5256 10.1854 24.6597 9.3194 23.5927 9.3194H10.7525C9.68548 9.3194 8.81952 10.1854 8.81952 11.2523V27.1853C8.81952 27.8193 8.29377 28.345 7.65976 28.345C7.02576 28.345 6.5 27.8193 6.5 27.1853V11.2523C6.5 8.90189 8.40201 6.99988 10.7525 6.99988ZM14.3974 16.3608V30.278C14.3974 31.345 15.2634 32.2109 16.3304 32.2109H30.2475C31.3145 32.2109 32.1805 31.345 32.1805 30.278V16.3608C32.1805 15.2938 31.3145 14.4279 30.2475 14.4279H16.3304C15.2634 14.4279 14.3974 15.2938 14.3974 16.3608Z",
    fill: "#18818B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8613 20.9999C29.8613 21.6339 29.3356 22.1596 28.7016 22.1596H17.8771C17.2431 22.1596 16.7173 21.6339 16.7173 20.9999C16.7173 20.3658 17.2431 19.8401 17.8771 19.8401H28.7016C29.3356 19.8401 29.8613 20.3658 29.8613 20.9999Z",
    fill: "#18818B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2632 26.0256H24.4486C25.0826 26.0256 25.6084 26.5514 25.6084 27.1854C25.6084 27.8194 25.0826 28.3452 24.4486 28.3452H18.2632C17.6292 28.3452 17.1035 27.8194 17.1035 27.1854C17.1035 26.5514 17.6292 26.0256 18.2632 26.0256Z",
    fill: "#18818B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.9d498329.svg";
export { ForwardRef as ReactComponent };